import { all } from "redux-saga/effects";
//import categorySaga from "./handlers/categories";
import staffSaga from "./handlers/staff";
//import societeSaga from "./handlers/societe";

export default function* rootSaga() {
 // yield all([categorySaga()]);
  yield all([staffSaga()]);
  //yield all([societeSaga()]);
  

}